export default {
  placeholder: 'Wählen Sie einen Status aus',
};
